
import { GeoAddressArea } from '@/domain/entities/ManageArea';
import { Options, prop, Vue } from 'vue-class-component';
import Checkbox from "primevue/checkbox";


class Props {
  geoAddress = prop<GeoAddressArea>({
    required: true,
    type: Object
  });
  modelValue = prop<number[]>({
    default: () => [],
    type: Array
  });
}

@Options({
  name: "Tree",
  components: {
    Checkbox
  }
})
class Tree extends Vue.with(Props) {
  isOpen = false;

  get model() {
    return this.modelValue;
  }

  set model(values: number[]) {
    this.$emit("update:modelValue", [...new Set(values)]);
  }

  openTree() {
    this.isOpen = !this.isOpen;
  }

  async onCheck(event: any, geoAddress: GeoAddressArea) {
    event.stopPropagation();
    this.handleCheck(geoAddress);
  }

  async handleCheck(geoAddress: GeoAddressArea) {
    await this.$nextTick();

    if (geoAddress.geoAddressId && geoAddress.isChecked(this.model)) {
      this.model.splice(this.model.findIndex(id => id === geoAddress.geoAddressId), 1)
      return
    }
    if (geoAddress.geoAddressId) {
        if (!this.model.includes(geoAddress.geoAddressId)) this.model.push(geoAddress.geoAddressId);
      return
    }


    if (geoAddress.isHaveChildren && geoAddress.isChecked(this.model)) {
      this.handleCheckParentActive(geoAddress)
    } else if (geoAddress.isHaveChildren) {
      for (const child of geoAddress.children) {
        await this.handleCheckParent(child);
      }
    }
  }

  async handleCheckParent(geoAddress: GeoAddressArea) {
    await this.$nextTick();
    if (geoAddress.geoAddressId) {
      if (!this.model.includes(geoAddress.geoAddressId)) this.model.push(geoAddress.geoAddressId);
      return
    } else {
      for (const child of geoAddress.children) {
        await this.handleCheckParent(child);
      }
    }
  }

  async handleCheckParentActive(geoAddress: GeoAddressArea) {
    await this.$nextTick();
    if (this.model.includes(geoAddress.geoAddressId)) {
      this.model.splice(this.model.findIndex(id => id === geoAddress.geoAddressId), 1)
    } else {
      for (const child of geoAddress.children) {
        await this.handleCheckParentActive(child);
      }
    }
  }
}

export default Tree;
